var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1142 318L1142 346",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1142.5,
    cy: 313.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.99 313.19C1137.99 309.283 1141.29 306.117 1145.36 306.117C1145.94 306.117 1146.51 306.184 1147.06 306.308C1145.74 305.48 1144.19 305 1142.52 305C1137.81 305 1134 308.806 1134 313.5C1134 318.194 1137.81 322 1142.52 322C1144.81 322 1146.89 321.093 1148.43 319.62C1147.49 320.032 1146.45 320.263 1145.36 320.263C1141.29 320.263 1137.99 317.096 1137.99 313.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.4 312.6L1151.37 310.146L1149.54 311.719L1147.3 311.056L1148.11 313.337L1146.77 315.381L1149.1 315.218L1150.5 317.144L1151.13 314.763L1153.34 313.909L1151.4 312.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch2);
export default __webpack_public_path__ + "static/media/church_2.091b41fddc2403c351d224d1ccfe78c7.svg";
export { ForwardRef as ReactComponent };